export const locations: Record<string, { name: string; code: string }> = {
    "T": { name: "業務(零售)", code: "T" },
    "A": { name: "台北", code: "A" },
    "B": { name: "新北", code: "B" },
    "C": { name: "基隆", code: "C" },
    "D": { name: "桃園", code: "D" },
    "E": { name: "新竹", code: "E" },
    "F": { name: "苗栗", code: "F" },
    "G": { name: "台中", code: "G" },
    "H": { name: "彰化", code: "H" },
    "I": { name: "南投", code: "I" },
    "J": { name: "雲林", code: "J" },
    "K": { name: "嘉義", code: "K" },
    "L": { name: "台南", code: "L" },
    "M": { name: "高雄", code: "M" },
    "N": { name: "屏東", code: "N" },
    "O": { name: "宜蘭", code: "O" },
    "P": { name: "花蓮", code: "P" },
    "Q": { name: "台東", code: "Q" },
    "R": { name: "澎湖", code: "R" },
    "S": { name: "綠島", code: "S" },
    "U": { name: "蘭嶼", code: "U" },
    "V": { name: "金門", code: "V" },
    "W": { name: "馬祖", code: "W" }
};
